module.exports = __webpack_public_path__ + "static/img/Service_en.7d56fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/customer_service/Service_en.png
// module id = 7xPD
// module chunks = 3